export const consumerChannel = [
  { label: "C-Cart - Online Card Sales/Enrollment", value: 0 },
  {
    label: "C-Cart - Mobile App Card Sales/Enrollment",
    value: 1,
  },
  { label: "Cardholder Website (C-Holder)", value: 2 },
  { label: "C-Holder Mobile Application (Native)", value: 3 },
  { label: "C-Touch - Interactive Voice Response - IVR", value: 4 },
  { label: "Customer Services - Live Operator", value: 5 },
  { label: "Other", value: 6 },
];
export const credit_consumerChannel = [
  { label: "C-Holder Website (Card Management Website)", value: 0 },
  {
    label: "C-Holder Mobile Application (Native iOS and Android)",
    value: 1,
  },
  { label: "C-Cart (Self Service Enrollment Portal)", value: 2 },
  { label: "C-Touch (IVR – Interactive Voice Response)", value: 3 },
  // { label: "C-Touch - Interactive Voice Response - IVR", value: 4 },
  { label: "Live Operator (Contact Center Service)", value: 5 },
  { label: "Other", value: 6 },
];
export const merchantChannel = [
  { label: "C-Partner Portal (Bulk card ordering interface)", value: 0 },
  { label: "WebPOS - Web-based Point-of-Sale Portal", value: 1 },
  { label: "Other", value: 2 },
];
export const credit_merchantChannel = [
  { label: "C-Partner Portal (Bulk card ordering interface)", value: 0 },
  { label: "Other", value: 1 },
];
export const otherChannel = [
  { label: "Web Services API (VPN required)", value: 0 },
  { label: "Communication Link", value: 1 },
  { label: "Fastsettle (Settlement & Reconciliation)", value: 2 },
  { label: "Other", value: 3 },
];

export const credit_otherChannel = [
  { label: "Web Services API (VPN required)", value: 0 },
  { label: "Fastsettle (Settlement & Reconciliation)", value: 1 },
  { label: "Other", value: 2 },
];
